export default __webpack_public_path__ + "static/media/icon-video-pink.b7c78e16.svg";